<template>
    <section class="signup-section spad set-bg">
        <div class="signup-warp d-flex">
            <!-- signup form -->
            <div class="signup-container ml-auto mr-auto mt-sm-5">
                <form class="signup-form m-3 m-sm-0 pt-5" v-on:submit.prevent="login">
                    <p class="h2 mb-4">Inicia sesión</p>
                    <input type="email" name="correo" id="correo" :class="{'margin-zero': errors.has('correo')}" placeholder="Correo electrónico" v-model="user.email" v-validate="'required'">
                    <p class="form-error" v-show="errors.has('correo')">{{ errors.first('correo') }}</p>
                    <input type="password" name="password" id="password" :class="{'margin-zero': errors.has('password')}" placeholder="Contraseña" v-model="user.password" v-validate="'required'">
                    <p class="form-error" v-show="errors.has('password')">{{ errors.first('password') }}</p>
                    <input type="submit" value="Entrar" class="site-btn" v-if="!loading">
                    <div class="loader-container" v-else>
                        <div class="loader"></div>
                    </div>
                    <p class="api-error" v-if ="errorMsg">{{errorMsg}}</p>	
                    <p class="recover-link"><router-link to="/recuperar">¿Has olvidado tu contraseña?</router-link></p>			
                </form>
            </div>
        </div>
	</section>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import { Validator } from 'vee-validate';
import messagesEs from 'vee-validate/dist/locale/es.js';

import { API_URL } from '@/config.js'

Vue.use(VeeValidate, {
    locale: 'es',
    events: 'blur',
    dictionary: {
        es: messagesEs
    }
});

Validator.localize('es', { 
    custom: {
        correo: {
            email: 'Debes introducir un correo electrónico válido',
            required: 'Debes introducir tu correo electrónico'
        },
        password: {
            required: 'Debes introducir tu contraseña'
        },
        repeatPassword: {
            required: 'Debes introducir de nuevo la contraseña'
        }
    }
});

export default {
    name: 'register',
    data() {
        return {
            user: {
                email: null,
                password: null,
            },
            errorMsg: null,
            loading: false
        }
    },
    methods: {
        login() {
            this.loading = true;
            this.errorMsg = null;
            this.$validator.validate().then(valid => {
                if (valid) {
                    let chain = btoa(`${this.user.email}:${this.user.password}`);
                    axios.post(`${API_URL}/public/security/login`, {
                        chain: chain
                    })
                        .then(response => {
                            this.loading = false;
                            if (response.status == 200) {
                                localStorage.setItem('token', response.data.token);
                                this.$store.commit('setUserToken', response.data.token);
                                this.$store.commit('setUserEmail', this.user.email);
                                this.$router.push('/');
                            } else {
                                console.log(response);
                                this.errorMsg = "Se ha producido un error al iniciar sesión";
                            }
                        })
                        .catch(err => {
                            this.loading = false;
                            this.errorMsg = err.response.data["Message"];
                        });
                } else {
                    this.loading = false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "@/variables.scss";

    .signup-section {
        min-height: calc(100vh - 48px);
        padding-top: $header-unauth-height;
        background-color: $main-color-brown;
        background-image: url("https://www.justcompileit.com/videos/cursos-streaming/images/register.jpg");
        .signup-container {
            width: 100vw;
            max-width: 700px;
            box-sizing: border-box;
        }
        .signup-form {
            input[type=password] {
                height: 57px;
                width: 100%;
                padding: 0 30px;
                margin-bottom: 27px;
                float: left;
                border: none;
                font-size: 14px;
                font-weight: 500;
                background: #edf4f6;
            }
            input.margin-zero {
                margin-bottom: 4px;
                background-color:#ffdfdf;
            }
            .form-error {
                display: inherit;
                text-align: left;
                color: red;
                margin-left: 10px;
                margin-bottom: 8px;
                line-height: 16px;
            }
            .api-error {
                color: red;
                margin: 15px 10px -10px;
                font-size: 16px;
            }
            .recover-link {
                font-size: 16px;
                margin-top: 25px;
                margin-bottom: 0;
            }
        }
    }
</style>

